import * as React     from "react"
import PropTypes      from "prop-types"
import _              from "lodash"
import ChartComponent from "react-chartjs-2"
import { Pie, Bar }   from "react-chartjs-2"
import { injectIntl } from "react-intl"
import RatiosTable    from "../ratios-table"
import ModalChart     from "../modal-chart"
import ExportTable    from "../export-table"

export const CHART_SECTIONS = {
	EXPENSE : "CHART_SECTIONS.EXPENSE",
	RECEIPTS: "CHART_SECTIONS.RECEIPTS"
}

class SynthesisComponent extends React.Component {

	constructor(props) {
		super(props)

		this.pieChartOptions = {
			maintainAspectRatio: false,
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex]
					const total          = _.sum(data.datasets[datasetIndex].data)
					const percentage     = total ? _.round(value * 100 / total) : 0
					const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					return `${data.labels[dataIndex]} : ${formattedValue} (${percentage}%)`
				}
			}}
		}

		this.barChartOptions = {
			maintainAspectRatio: false,
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
						callback: (value, index, values) => {
							return this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
						}
					}
				}]
			},
			tooltips: { callbacks: {
				label: (tooltip, data) => {
					const datasetIndex   = tooltip.datasetIndex
					const dataIndex      = tooltip.index
					const value          = data.datasets[datasetIndex].data[dataIndex]
					const total          = _.sum(data.datasets[datasetIndex].data)
					const percentage     = total ? _.round(value * 100 / total) : 0
					const formattedValue = this.props.intl.formatNumber(value, { currency: "EUR", style: "currency" })
					return `${data.datasets[datasetIndex].label} : ${formattedValue} (${percentage}%)`
				}
			}}
		}

		this.modalTabs = [
			{ id: CHART_SECTIONS.RECEIPTS, label: "Recettes réelles" },
			{ id: CHART_SECTIONS.EXPENSE,  label: "Dépenses réelles" }
		]
	}

	render() {
		const displayCharts = this.props.displayCharts
		const loading       = this.props.loading
		const titleOptions  = this._getTitleOptions(this.props)
		return (
			<div style={{ height: "100%", overflow: "auto", width: "100%" }}>
				{!loading && <button className="button is-text" onClick={this.props.onClickShowCharts}>Afficher les graphiques</button>}
				<ExportTable data={this.props.tableData} slug={this.props.slug} id={this.props.id} years={this.props.years} />
				<br/>
				<RatiosTable data={this.props.tableData} years={this.props.years} />

				{displayCharts && (
					<ModalChart
					displayCharts        = {displayCharts}
					onClickChartModalTab = {this.props.onClickChartModalTab}
					onClickHideCharts    = {this.props.onClickHideCharts}
					title                = "Synthèse par chapitre de fonctionnement"
					tabs                 = {this.modalTabs}>
						<div style={{ position: "relative", height: "400px" }}>
							<Pie data={this.props.pieChartData} options={{...this.pieChartOptions, title: titleOptions.pieChart}} />
						</div>
						<div style={{ position: "relative", height: "400px" }}>
							<Bar data={this.props.totalChartData} options={{...this.barChartOptions, title: titleOptions.totalChart}} />
						</div>
						<p style={{textAlign:"center"}}>Vous pouvez cacher un élément sur le graphique en cliquant sur sa légende.</p>
						<div style={{ position: "relative", height: "400px" }}>
							<Bar data={this.props.perInhabitantChartData} options={{...this.barChartOptions, title: titleOptions.perInhabitantChart}} />
						</div>
						<p style={{textAlign:"center"}}>Vous pouvez cacher un élément sur le graphique en cliquant sur sa légende.</p>
					</ModalChart>
				)}
			</div>
		)
	}

	_getTitleOptions = (props) => {
		const defaultTitleOptions = { display: true }
		return {
			perInhabitantChart: {
				...defaultTitleOptions,
				text: props.modalTitles.perInhabitantChart
			},
			pieChart: {
				...defaultTitleOptions,
				text: props.modalTitles.pieChart
			},
			totalChart: {
				...defaultTitleOptions,
				text: props.modalTitles.totalChart
			}
		}
	}
}

export default injectIntl(SynthesisComponent)

SynthesisComponent.propTypes = {
	tableData             : PropTypes.array.isRequired,
	displayCharts         : PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.oneOf([CHART_SECTIONS.EXPENSE, CHART_SECTIONS.RECEIPTS])
	]).isRequired,
	loading               : PropTypes.bool.isRequired,
	modalTitles           : PropTypes.shape({
		pieChart          : PropTypes.string,
		totalChart        : PropTypes.string,
		perInhabitantChart: PropTypes.string
	}).isRequired,
	onClickChartModalTab  : PropTypes.func.isRequired,
	onClickShowCharts     : PropTypes.func.isRequired,
	onClickHideCharts     : PropTypes.func.isRequired,
	perInhabitantChartData: ChartComponent.propTypes.data,
	pieChartData          : ChartComponent.propTypes.data,
	totalChartData        : ChartComponent.propTypes.data,
	years                 : PropTypes.arrayOf(PropTypes.number).isRequired
}


// WEBPACK FOOTER //
// ./src/component/ratios/synthesis/synthesis-component.js